var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "field-container" }, [
    _c("div", { staticClass: "label-container" }, [
      _c("div", { staticClass: "label-field" }, [
        _vm._v(
          " " +
            _vm._s(_setup.$map.trans("map.measurement.setting.field.data")) +
            " "
        ),
      ]),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "setting-button",
            attrs: {
              disabled: !_setup.model || _setup.model.length < 1,
              title: _setup.$map.trans("map.measurement.action.fly-to"),
            },
            on: { click: _setup.onFlyTo },
          },
          [
            _c(_setup.SvgIcon, {
              attrs: {
                size: 16,
                type: "mdi",
                path: _setup.path.fillBound,
                title: _setup.$map.trans("map.measurement.action.download"),
              },
            }),
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "setting-button",
            attrs: { disabled: !_setup.model || _setup.model.length < 1 },
            on: { click: _setup.onDownload },
          },
          [
            _c(_setup.SvgIcon, {
              attrs: {
                size: 16,
                type: "mdi",
                path: _setup.path.download,
                title: _setup.$map.trans("map.measurement.action.add-point"),
              },
            }),
          ],
          1
        ),
        _setup.isCanAdd
          ? _c(
              "button",
              {
                staticClass: "setting-button",
                on: { click: _setup.onAddItem },
              },
              [
                _c(_setup.SvgIcon, {
                  attrs: { size: 16, type: "mdi", path: _setup.path.add },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "geometry-list-container" },
      _vm._l(_setup.model, function (item, index) {
        return _c("div", { key: index, staticClass: "geometry-list-item" }, [
          _c("div", [_vm._v(" #" + _vm._s(index + 1) + " ")]),
          _c("div", {}, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.model[index][0],
                  expression: "model[index][0]",
                },
              ],
              staticClass: "setting-input",
              attrs: { type: "number", step: "any" },
              domProps: { value: _setup.model[index][0] },
              on: {
                change: function ($event) {
                  return _setup.onUpdatePathItem(index)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_setup.model[index], 0, $event.target.value)
                },
              },
            }),
          ]),
          _c("div", {}, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.model[index][1],
                  expression: "model[index][1]",
                },
              ],
              staticClass: "setting-input",
              attrs: { type: "number", step: "any" },
              domProps: { value: _setup.model[index][1] },
              on: {
                change: function ($event) {
                  return _setup.onUpdatePathItem(index)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_setup.model[index], 1, $event.target.value)
                },
              },
            }),
          ]),
          _c("div", {}, [
            _c(
              "button",
              {
                staticClass: "setting-button",
                on: {
                  click: function ($event) {
                    return _setup.onDeleteItem(index)
                  },
                },
              },
              [
                _c(_setup.SvgIcon, {
                  attrs: { size: 16, type: "mdi", path: _setup.path.delete },
                }),
              ],
              1
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }